import React from 'react';
import { View, Svg, Line, Circle, Text } from '@react-pdf/renderer';
import type { Goal } from '../types';

interface GoalDiagramPDFProps {
  goals: Goal[];
  width?: number;
  height?: number;
}

const GoalDiagramPDF: React.FC<GoalDiagramPDFProps> = ({ 
  goals,
  width = 200,
  height = 150
}) => {
  return (
    <View style={{ width, height }}>
      <Svg viewBox="-5 -5 110 110" width={width} height={height}>
        {/* Goal frame */}
        <Line x1={0} y1={0} x2={100} y2={0} stroke="#ef4444" strokeWidth={2} />
        <Line x1={0} y1={0} x2={0} y2={100} stroke="#ef4444" strokeWidth={2} />
        <Line x1={100} y1={0} x2={100} y2={100} stroke="#ef4444" strokeWidth={2} />

        {/* Grid lines */}
        {[25, 50, 75].map((pos) => (
          <React.Fragment key={pos}>
            <Line x1={pos} y1={0} x2={pos} y2={100} stroke="#d1d5db" strokeWidth={0.5} />
            <Line x1={0} y1={pos} x2={100} y2={pos} stroke="#d1d5db" strokeWidth={0.5} />
          </React.Fragment>
        ))}

        {/* Goals */}
        {goals.map((goal, index) => (
          <React.Fragment key={goal.id}>
            <Circle
              cx={goal.xPosition}
              cy={goal.yPosition}
              r={1.5}
              fill="#ef4444"
            />
            <Text
              x={goal.xPosition + 2}
              y={goal.yPosition - 2}
              style={{
                fontSize: 8,
                fill: '#374151'
              }}
            >
              {index + 1}
            </Text>
          </React.Fragment>
        ))}
      </Svg>
    </View>
  );
};

export default GoalDiagramPDF;